import Vue from 'vue'
import VueRouter, { RouteConfig, Route, NavigationGuardNext } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'

// import authGuard from '@/router/guards/authGuard'

import BaselineLayout from '@/ui/layouts/BaselineLayout.vue'
import CenteredLayout from '@/ui/layouts/CenteredLayout.vue'
import BlankLayout from '@/ui/layouts/BlankLayout.vue'

import Home from '@/ui/views/Home.vue'
import ContainerRowCol from '@/ui/views/ContainerRowCol.vue'

import BlankComponent from '@/ui/components/BlankComponent.vue'
import NotFoundComponent from '@/ui/components/NotFoundComponent.vue'

import plants from './plants'

interface JRoute {
  params: Dictionary<string | string[]>
}

const stringsToArrays =
  (...params: string[]) =>
  (to: JRoute, from: Route, next: NavigationGuardNext<Vue>) => {
    params.forEach(
      (param: string) =>
        (to.params[param] = (to.params[param] as string)
          .split(',')
          .map((p: string) => p.trim()))
    )
    next()
  }

// const appendParams = (additionalParams: object) => (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
//   Object.entries(additionalParams)
//     .map((entries: any[]) => {
//       const key: string = entries[0]
//       const value: any = entries[1]
//       to.params[key] = value
//     })

//   next()
// }

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: BaselineLayout,
    children: [
      {
        path: '/',
        component: BlankComponent,
        // beforeEnter: authGuard,
        children: [
          // {
          //   path: 'test',
          //   name: 'test',
          //   component: () => import('@/ui/components/TestComponent.vue'),
          // },
          {
            path: '/',
            name: 'home',
            redirect: { name: 'gardens' },
          },
          {
            path: 'dashboard',
            name: 'dashboard',
            component: Home,
          },
          {
            path: 'gardens',
            name: 'gardens',
            component: () => import('@/ui/components/gardens/GardensGrid.vue'),
          },
          {
            path: '/',
            component: ContainerRowCol,
            children: [
              {
                path: 'timeline/:imageId?',
                name: 'timeline',
                props: true,
                component: () =>
                  import('@/ui/components/timeline/AllLogTimeline.vue'),
              },
              {
                path: 'images/:imageId?',
                name: 'images',
                props: true,
                component: () =>
                  import('@/ui/components/images/AllImageGallery.vue'),
              },

              {
                // GardenCard
                path: 'gardens/:gardenId',
                name: 'garden',
                props: true,
                component: () =>
                  import('@/ui/components/gardens/GardenCard.vue'),
                children: [
                  // moved to ./plants/index.ts

                  {
                    path: 'add/image/:plantIds?',
                    name: 'garden/add/image',
                    props: true,
                    meta: { showDialog: true, dialogIsScrollable: true },
                    component: () => import('@/ui/components/AddImage.vue'),
                    beforeEnter: stringsToArrays('plantIds'),
                  },

                  {
                    path: 'add/log/:category/:plantIds?',
                    name: 'garden/add/log',
                    props: true,
                    meta: { showDialog: true, dialogIsScrollable: true },
                    component: () => import('@/ui/components/AddLog.vue'),
                    beforeEnter: stringsToArrays('plantIds'),
                  },

                  {
                    path: 'plants/:plantId/harvests/add',
                    name: 'garden/add/harvest',
                    props: true,
                    meta: { showDialog: true, dialogIsScrollable: true },
                    component: () => import('@/ui/components/AddHarvest.vue'),
                    // beforeEnter: appendParams({ fullscreen: true }),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  // PlantInfo
  {
    path: '/',
    component: BaselineLayout,
    props: {
      showToolbarExtension: true,
      showTitleComponent: true,
      hideToolbarOnScroll: false,
    },
    children: [
      {
        path: 'gardens/:gardenId',
        props: { default: false, toolbarExtension: true, title: true },
        // props: (route) => Object.assign({}, route.params, { showExtension: true } ),
        components: {
          default: BlankComponent,
          toolbarExtension: () =>
            import('@/ui/components/gardens/GardenPlantTabs.vue'),
          title: () => import('@/ui/components/gardens/GardenTitle.vue'),
        },
        children: [
          plants, // PlantInfo
        ],
      },
    ],
  },

  {
    path: '/',
    component: CenteredLayout,
    children: [
      // {
      //   path: 'register',
      //   name: 'register',
      //   component: () => import('@/ui/components/users/Register.vue')
      // },
      // {
      //   path: 'login',
      //   name: 'login',
      //   component: () => import('@/ui/components/users/Login.vue')
      // },

      {
        path: 'token',
        name: 'get-token',
        component: () => import('@/ui/components/users/GetToken.vue'),
      },

      // {
      //   path: 'password/change',
      //   name: 'change-password',
      //   component: () => import('@/ui/components/users/ChangePassword.vue'),
      // },
    ],
  },

  {
    path: '/',
    component: BlankLayout,
    children: [{ path: '*', component: NotFoundComponent }],
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '@/ui/views/About.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
